import { render } from "./editBusinessUnit.vue?vue&type=template&id=5cdda812&scoped=true"
import script from "./editBusinessUnit.vue?vue&type=script&lang=js"
export * from "./editBusinessUnit.vue?vue&type=script&lang=js"

import "./editBusinessUnit.vue?vue&type=style&index=0&id=5cdda812&scoped=true&lang=css"

import exportComponent from "/home/quantum/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cdda812"]])

export default __exports__